//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['inuser'],
    data: function data() {
        return {
            properties: [],
            userId: null,
            user: {},
            first_name: '',
            last_name: '',
            email: '',
            role: [],
            roles: [],
            selectedProperties: []
        };
    },

    computed: {
        parseRoles: function parseRoles() {
            var output = [],
                self = this;

            this.roles.forEach(function (r, index) {
                output.push({
                    label: self.unslugify(r.name),
                    value: r.name
                });
            });

            return output;
        }
    },
    methods: {
        refreshData: function refreshData() {
            var $el = this;

            axios.get('/prototype/properties/quick/lookup').then(function (response) {
                if (response.data) {

                    $el.properties = response.data.properties;
                }
            });
        },
        deleteUser: function deleteUser() {

            var self = this;

            var sendData = {
                id: this.user.id
            };

            window.axios.post('/prototype/users/delete', sendData).then(function (response) {
                if (response.data) {
                    Event.$emit('refresh-users-and-roles');
                    Event.$emit('close-small-modal');
                }
            });
        },
        getUsersAndRoles: function getUsersAndRoles() {

            var self = this;

            window.axios.get('/prototype/user-api/all').then(function (response) {
                self.users = response.data.users;
                self.roles = response.data.roles;
            });
        },
        unslugify: function unslugify(text) {

            if (!text) return 'No Role Assigned';

            var t = text.replace('-', ' ').split(' ').map(function (s) {
                return s.charAt(0).toUpperCase() + s.substring(1);
            }).join(' ');

            return t;
        },
        closeModal: function closeModal() {
            this.clearUser();
            Event.$emit('close-small-modal');
        },
        create: function create() {

            var self = this;

            var properties = [],
                roles = [];

            this.selectedProperties.forEach(function (element, index) {
                properties.push(typeof element == 'string' ? element : element.name);
            });

            this.role.forEach(function (element, index) {
                roles.push(typeof element == 'string' ? element : element.name);
            });

            window.axios.post('/prototype/user-api/update', {
                id: this.userId,
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                roles: roles,
                properties: properties
            }).then(function (response) {
                self.clearUser();
                Event.$emit('refresh-users-and-roles');
                Event.$emit('close-small-modal');
            });
        },
        clearUser: function clearUser() {
            this.user = {
                first_name: '',
                last_name: '',
                email: '',
                role: '',
                selectedProperties: []
            };
        },
        showEditUser: function showEditUser(userId) {
            var $el = this;

            $el.$children[0].$data.showSmallModal = true;

            // Populate properties and roles
            this.refreshData();

            this.getUsersAndRoles();

            this.userId = userId;

            window.axios.post('/prototype/user-api/view', {
                id: userId
            }).then(function (response) {
                console.log('USER', response.data);

                var theUser = response.data;

                // Parse user name
                $el.user = theUser;
                $el.first_name = theUser.first_name;
                $el.last_name = theUser.last_name;
                $el.email = theUser.email;

                // Parse the user's roles
                var selectedRoles = [],
                    selectedProperties = [];

                theUser.property.forEach(function (element, index) {
                    selectedProperties.push(element.name);
                });

                // Parse the user's properties
                theUser.roles.forEach(function (element, index) {
                    selectedRoles.push(element.name);
                });

                $el.role = selectedRoles;
                $el.selectedProperties = selectedProperties;
            });
        },
        changeUserActiveStatus: function changeUserActiveStatus(user) {
            window.axios.put('/prototype/user-api/activation/' + this.user.id).then(function (res) {
                Event.$emit('refresh-users-and-roles');
                Event.$emit('close-small-modal');
            });
        }
    },
    created: function created() {
        Event.$on('edit-user', this.showEditUser);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-user');
    },
    mounted: function mounted() {
        var $el = this;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/users/UserEdit.vue
// module id = sH1Y
// module chunks = 0 1